import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledWithdrawal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  .reject-withdrawal-note {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid ${COLOR.functionalRed[16]};
    background: ${COLOR.functionalRed[8]};
    height: 40px;
    box-sizing: border-box;
  }
`;

export const StyledWithDrawalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  .tax-info-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 12px;
    background-color: ${COLOR.bluev2[8]};
    border-radius: 8px;
    gap: 8px;
    .tax-info-icon {
      width: 24px;
      height: 24px;
      color: ${COLOR.blueV2};
    }
  }
  .confirm-request-withdrawal-checkbox-container {
    margin: 0px;
    gap: 8px;
    .MuiFormControlLabel-label {
      font-size: 14px;
      font-weight: 400;
    }
    .confirm-request-withdrawal-checkbox {
      padding: 0px;
    }
  }
`;

export const StyledActionButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 24px 0 0 0;
  .btn-loading {
    color: ${COLOR.indigo.default};
  }
`;
